import { useState } from "react";
import { Company, User } from "../../types";
import { useQuery } from "@tanstack/react-query";
import { AdminCompanySelect } from "./AddUserToCompany";
import format from "date-fns/format";
import { Account } from "@mysnowscape/snow-lib";
export default function CompanyDetails() {
  const [company, setCompany] = useState<Company | null>();
  const accountQuery = useQuery<{
    owner: User;
    account: Account;
    company: Company;
  }>({
    queryKey: [`/company/${company?._id}/account`],
    enabled: company?._id != null,
  });
  const user = accountQuery.data?.owner;
  return (
    <div>
      <h2 className="text-lg font-bold">Company Details</h2>
      <AdminCompanySelect name="company_id" onChange={setCompany} />
      {company && (
        <table>
          <tr>
            <th className="text-left">Name</th>
            <td>{company.name}</td>
          </tr>
          <tr>
            <th className="text-left">Owner</th>
            <td>
              {user &&
                `${user.firstName} ${user.lastName} (${user.phoneNumber})`}
            </td>
          </tr>
          <tr>
            <th className="text-left">
              Stripe Customer
              <div className="text-xs text-gray-500 font-normal">
                Search with this in the Stripe dashboard
              </div>
            </th>
            <td>{accountQuery.data?.account?.stripe?.customerId}</td>
          </tr>
          <tr>
            <th className="text-left">Created</th>
            <td>{format(new Date(company.createdAt), "MMM d, yyyy")}</td>
          </tr>
          <tr>
            <th className="text-left">Active Employees</th>
            <td>
              {
                Object.values(company.authorizedUsers).filter((u) => u.active)
                  .length
              }
            </td>
          </tr>
          <tr>
            <th className="text-left">Timezone</th>
            <td>{company.timezone}</td>
          </tr>
        </table>
      )}
    </div>
  );
}
